'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  workerPath: '{{JSNETWORKX_BUNDLE}}'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/jsnetworkx/node/WorkerSettings.js
// module id = 340
// module chunks = 0